export const SET_DATA = 'telegram/SET_DATA';
export const SET_TELEGRAM_LOGGED_IN_STATUS = 'telegram/SET_TELEGRAM_LOGGED_IN_STATUS';
